document.addEventListener("click", event => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const link = target.closest("a[data-click]");
  const clickPayload = link?.getAttribute("data-click");
  if (!clickPayload) return;

  fetch("/api/clicktracking/track", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(clickPayload),
    keepalive: true,
  }).catch(() => {});
});
